<div class="flex flex-row">
    <div class="relative">
        <input
            class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px py-2.5 max-w-150px pl-10 bg-no-repeat bg-left mr-3"
            style="background-image: url('./assets2023/img/icons/calendar.svg'); background-position-x: 8px;"
            placeholder="{{ 'filter_from' | translate }}"
            angular-mydatepicker
            name="mydateFrom"
            (click)="dpFrom.toggleCalendar()"
            [(ngModel)]="myDpModelFrom"
            (ngModelChange)="onMyDpModelFromChange()"
            [options]="myDpOptionsFrom"
            locale="es"
            #dpFrom="angular-mydatepicker"
        >
    </div>

    <div class="relative">
        <input
        class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px py-2.5 max-w-150px pl-10 bg-no-repeat bg-left"
        style="background-image: url('./assets2023/img/icons/calendar.svg'); background-position-x: 8px;"
        placeholder="{{ 'filter_to' | translate }}"
        angular-mydatepicker
        name="mydateTo"
        (click)="dpTo.toggleCalendar()"
        [(ngModel)]="myDpModelTo"
        (ngModelChange)="onMyDpModelToChange()"
        [options]="myDpOptionsTo"
        locale="es"
        #dpTo="angular-mydatepicker"
        >
    </div>
</div>
